import Image from 'next/image';

import { Button } from '../components/Button';

export const Awards = () => {
  return (
    <section className={'ourAwards'}>
      <div className="section-wrapper align-center justify-center flex-column">
        <div className={'driveAwards'}>
          <div className={'driveAwardsCard'}>
            <div className={'driveAwardsCardImage'}>
              <Image
                width={120}
                height={120}
                src={'/drive-award-2.svg'}
                alt="Drive Agency Award"
              />
            </div>
            <p>Drive Agency Award</p>
          </div>
          <div className={'driveAwardsCard'}>
            <div className={'driveAwardsCardImage'}>
              <Image
                width={120}
                height={120}
                src={'/drive-award-1.svg'}
                alt="Drive Agency Award"
              />
            </div>

            <p>Drive Agency Award</p>
          </div>
          <div className={'driveAwardsCard'}>
            <div className={'driveAwardsCardImage'}>
              <Image
                width={120}
                height={120}
                src={'/drive-award-2.svg'}
                alt="Drive Agency Award"
              />
            </div>
            <p>Drive Agency Award</p>
          </div>
          <div className={'driveAwardsCard'}>
            <div className={'driveAwardsCardImage'}>
              <Image
                width={120}
                height={120}
                src={'/drive-award-1.svg'}
                alt="Drive Agency Award"
              />
            </div>

            <p>Drive Agency Award</p>
          </div>
          <div className={'driveAwardsCard'}>
            <div className={'driveAwardsCardImage'}>
              <Image
                width={120}
                height={120}
                src={'/drive-award-3.svg'}
                alt="Drive Agency Award"
              />
            </div>
            <p>Drive Agency Award</p>
          </div>
        </div>
        <Button
          linkTo={'/our-awards'}
          className={'btn glowing-border'}
          title={'See all awards'}
        />
      </div>
    </section>
  );
};
